/**
 * Android app-download mark used in the China desktop footer (Figma node 6901:5588,
 * the 22px leaf inside the design's 28px icon box).
 *
 * Brand colours are fixed — the green disc and the white robot are part of the mark, so
 * this takes no `fill` prop unlike the single-colour icons in this folder.
 *
 * The Figma export wrapped the paths in a clipPath clipping to a 22x22 rect, i.e. the whole
 * viewBox. It was a no-op, and dropping it avoids a duplicate DOM id if the icon is ever
 * rendered more than once on a page.
 */
const AndroidStoreIcon = ({ height = "22", width = "22" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0C4.92456 0 0 4.92456 0 11C0 17.0748 4.92456 22 11 22C17.0754 22 22 17.0748 22 11C22 4.92456 17.0754 0 11 0Z"
      fill="#A3C939"
    />
    <path
      d="M6.30309 8.01099C5.83216 8.01099 5.44922 8.39324 5.44922 8.86486V12.2797C5.44922 12.7506 5.83147 13.1335 6.30309 13.1335C6.77472 13.1335 7.15697 12.7513 7.15697 12.2797V8.86486C7.15697 8.39324 6.77403 8.01099 6.30309 8.01099Z"
      fill="white"
    />
    <path
      d="M15.6937 8.01074C15.2228 8.01074 14.8398 8.39299 14.8398 8.86462V12.2794C14.8398 12.7504 15.2221 13.1333 15.6937 13.1333C16.1653 13.1333 16.5476 12.7511 16.5476 12.2794V8.86462C16.5476 8.39299 16.1653 8.01074 15.6937 8.01074Z"
      fill="white"
    />
    <path
      d="M7.58398 14.8411H8.43786V16.9758C8.43786 17.4467 8.82011 17.8297 9.29173 17.8297C9.76336 17.8297 10.1456 17.4474 10.1456 16.9758V14.8411H11.8534V16.9758C11.8534 17.4467 12.2356 17.8297 12.7072 17.8297C13.1789 17.8297 13.5611 17.4474 13.5611 16.9758V14.8411H14.415V8.43774H7.58467V14.8411H7.58398Z"
      fill="white"
    />
    <path
      d="M13.0159 5.25882L13.4545 4.49914C13.5137 4.3967 13.4786 4.26676 13.3762 4.20695C13.2744 4.14782 13.1438 4.18289 13.0847 4.28532L12.6564 5.02576C12.1655 4.75282 11.601 4.59607 10.9995 4.59607C10.3979 4.59607 9.83348 4.75282 9.34261 5.02645L8.91498 4.28532C8.85586 4.18357 8.72592 4.14851 8.6228 4.20695C8.52105 4.26607 8.48598 4.39601 8.54442 4.49845L8.98305 5.25814C8.13673 5.87964 7.58398 6.87926 7.58398 8.01089H14.4143C14.4143 6.87995 13.8622 5.88032 13.0159 5.25882ZM9.71867 6.73007C9.48286 6.73007 9.29173 6.53895 9.29173 6.30314C9.29173 6.06732 9.48286 5.8762 9.71867 5.8762C9.95448 5.8762 10.1456 6.06732 10.1456 6.30314C10.1456 6.53964 9.95517 6.73007 9.71867 6.73007ZM12.2803 6.73007C12.0445 6.73007 11.8534 6.53895 11.8534 6.30314C11.8534 6.06732 12.0445 5.8762 12.2803 5.8762C12.5161 5.8762 12.7072 6.06732 12.7072 6.30314C12.7072 6.53964 12.5161 6.73007 12.2803 6.73007Z"
      fill="white"
    />
  </svg>
);

export default AndroidStoreIcon;
